import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_2/BuildingInstructions_Images/MainModels`

const Pic1 = `${FullPath}/ScissorLift/1_1x.png`;
const Pic2 = `${FullPath}/ScissorLift/2_1x.png`;
const Pic3 = `${FullPath}/ScissorLift/3_1x.png`;
const Pic4 = `${FullPath}/ScissorLift/4_1x.png`;
const Pic5 = `${FullPath}/ScissorLift/5_1x.png`;
const Pic6 = `${FullPath}/ScissorLift/6_1x.png`;
const Pic7 = `${FullPath}/ScissorLift/7_1x.png`;
const Pic8 = `${FullPath}/ScissorLift/8_1x.png`;
const Pic9 = `${FullPath}/ScissorLift/9_1x.png`;
const Pic10 = `${FullPath}/ScissorLift/10_1x.png`;
const Pic11 = `${FullPath}/ScissorLift/11_1x.png`;
const Pic12 = `${FullPath}/ScissorLift/12_1x.png`;
const Pic13 = `${FullPath}/ScissorLift/13_1x.png`;
const Pic14 = `${FullPath}/ScissorLift/14_1x.png`;
const Pic15 = `${FullPath}/ScissorLift/15_1x.png`;
const Pic16 = `${FullPath}/ScissorLift/16_1x.png`;
const Pic17 = `${FullPath}/ScissorLift/17_1x.png`;
const Pic18 = `${FullPath}/ScissorLift/18_1x.png`;
const Pic19 = `${FullPath}/ScissorLift/19_1x.png`;
const Pic20 = `${FullPath}/ScissorLift/20_1x.png`;
const Pic21 = `${FullPath}/ScissorLift/21_1x.png`;
const Pic22 = `${FullPath}/ScissorLift/22_1x.png`;
const Pic23 = `${FullPath}/ScissorLift/23_1x.png`;
const Pic24 = `${FullPath}/ScissorLift/24_1x.png`;
const Pic25 = `${FullPath}/ScissorLift/25_1x.png`;
const Pic26 = `${FullPath}/ScissorLift/26_1x.png`;
const Pic27 = `${FullPath}/ScissorLift/27_1x.png`;
const Pic28 = `${FullPath}/ScissorLift/28_1x.png`;
const Pic29 = `${FullPath}/ScissorLift/29_1x.png`;
const Pic30 = `${FullPath}/ScissorLift/30_1x.png`;
const Pic31 = `${FullPath}/ScissorLift/31_1x.png`;
const Pic32 = `${FullPath}/ScissorLift/32_1x.png`;
const Pic33 = `${FullPath}/ScissorLift/33_1x.png`;
const Pic34 = `${FullPath}/ScissorLift/34_1x.png`;
const Pic35 = `${FullPath}/ScissorLift/35_1x.png`;
const Pic36 = `${FullPath}/ScissorLift/36_1x.png`;
const Pic37 = `${FullPath}/ScissorLift/37_1x.png`;
const Pic38 = `${FullPath}/ScissorLift/38_1x.png`;
const Pic39 = `${FullPath}/ScissorLift/39_1x.png`;


export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
        Pic8,
        Pic9,
        Pic10,
        Pic11,
        Pic12,
        Pic13,
        Pic14,
        Pic15,
        Pic16,
        Pic17,
        Pic18,
        Pic19,
        Pic20,
        Pic21,
        Pic22,
        Pic23,
        Pic24,
        Pic25,
        Pic26,
        Pic27,
        Pic28,
        Pic29,
        Pic30,
        Pic31,
        Pic32,
        Pic33,
        Pic34,
        Pic35,
        Pic36,
        Pic37,
        Pic38,
        Pic39,

    

    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}